import * as React from "react";

import {
  Box,
  Heading,
  Text,
  VStack,
} from "@chakra-ui/react";

export const Hero = ({ bg, title, subtitle, imageSrc, position }: any) => {
  return (
    <Box bg={bg} as="section" maxW={"100%"} textTransform={"uppercase"} height={{ base: "60vh", md: "70vh" }}>
      <Box
        px={{ base: 4, md: 16 }}
        height={{ base: "60vh", md: "70vh" }}
        backgroundImage={imageSrc}
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        backgroundPosition="center"
        display="flex"
        justifyContent={position}
      >
        <VStack
          height="inherit"
          maxW={{base: "343px", md: "590px"}}
          w="100%"
          gap={4}
          alignItems="flex-start"
          justifyContent="flex-end"
        >
          <Heading
            w={{base: "auto", md: "559px"}}
            as="h1"
            fontFamily="TradeGothic LT Bold"
            color="#09170D"
            fontSize={{base: "4xl", md: "5xl"}}
            lineHeight={"115%"}
          >
            {title}
          </Heading>
          <Text
            fontSize={{ base: "md", md: "xl"}}
            fontWeight={700}
            color="lightGray.50"
            bg="white"
            fontFamily="TradeGothic LT"
            p={6}
            textTransform={"uppercase"}
            lineHeight={"150%"}
          >
            {subtitle}
          </Text>
        </VStack>
      </Box>
      {/* <Flex
        id="image-wrapper"
        position="absolute"
        insetX="0"
        insetY="0"
        w="full"
        h="full"
        overflow="hidden"
        align="center"
      >
        <Box position="relative" w="full" h="full">
          <Img
            src={imageSrc}
            alt={imageAlt}
            w="full"
            h="full"
            objectFit="cover"
          />
        </Box>
      </Flex> */}
    </Box>
  );
};
